import { Component } from '@angular/core'
import { ColumnControlBaseComponent } from '../base/column-control-base.component'

@Component({
    selector: 'app-column-control-link',
    templateUrl: './column-control-link.component.html',
    styleUrls: ['./column-control-link.component.scss'],
    standalone: false
})
export class ColumnControlLinkComponent extends ColumnControlBaseComponent {}
